<template>
  <p>{{ arrivalDate }}</p>
</template>

<script>
export default {
  name: "FirstAvailableDate",
  props: ["date"],
  computed: {
    arrivalDate() {
      let currentDate = new Date();
      let auPairArrival = new Date(this.date);

      if (currentDate > auPairArrival) {
        return `Available since ${auPairArrival.toLocaleDateString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}`;
      }

      return `Available on ${auPairArrival.toLocaleDateString("en-us", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })}`;
    },
  },
};
</script>
